<template>
  <div class="track-picker-section">
    <div
      @click="open = !open"
      class="track-picker-section-header"
      :style="headerStyle"
    >
      <chevron-down-icon v-if="open" />
      <chevron-right-icon v-else />
      {{ tag.name }}
    </div>
    <div v-if="open" class="track-list">
      <div v-for="track in tracks" :key="track._id" class="track-list-item">
        <div class="track-list-item-name">{{ track.name }}</div>
        <a
          href="#"
          @click.prevent.stop="addTrack(track)"
          class="track-list-item-add"
        >
          <plus-icon />
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import {
  ChevronRightIcon,
  ChevronDownIcon,
  PlusIcon,
} from "@heroicons/vue/24/solid";
import { Tag, Track } from "@/models";

@Options({
  components: {
    ChevronRightIcon,
    ChevronDownIcon,
    PlusIcon,
  },
  props: {
    tag: {
      type: Object,
      required: true,
    },
    tracks: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      open: false,
    };
  },
})
export default class TrackPickerSection extends Vue {
  tag!: Tag;
  tracks!: Track[];
  open!: boolean;

  get headerStyle() {
    return {
      backgroundColor: `#${this.tag.color}50`,
    };
  }

  addTrack(track: Track) {
    this.$emit("add", track);
  }
}
</script>

<style lang="scss">
.track-picker-section-header {
  padding: 2px;
  font-weight: bold;
  cursor: pointer;
  svg {
    position: relative;
    top: 1.5px;
    width: 12px;
    height: 12px;
  }
}

.track-list-item {
  display: flex;
  align-items: center;
  padding: 4px 2px 4px 18px;

  .track-list-item-name {
    flex-grow: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .track-list-item-add {
    display: block;
    width: 16px;
    height: 16px;
    opacity: 0;
    transition: opacity 0.15s ease;
    svg {
      width: 16px;
      height: 16px;
    }
  }

  &:hover .track-list-item-add {
    opacity: 1;
  }
}
</style>
